import { render, staticRenderFns } from "./PosterText.vue?vue&type=template&id=4971b584&scoped=true&"
import script from "./PosterText.vue?vue&type=script&lang=js&"
export * from "./PosterText.vue?vue&type=script&lang=js&"
import style0 from "./PosterText.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PosterText.vue?vue&type=style&index=1&id=4971b584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971b584",
  null
  
)

export default component.exports